import React, { useEffect, useContext } from 'react'
import { Route, useHistory } from 'react-router-dom'
import * as tokenService from '../../services/token'
import { Props } from '../../../modules/types'
import * as actions from '../store/actions'
import { AppContext } from '../../index'
import { RequestState } from '../../../modules/types'
import { PageLayout } from '../../nav/components/PageLayout'

function PrivateRoute(props: Props) {
  const { state, execute } = useContext(AppContext)
  const { component: Component, ...rest } = props
  const { user, requestState } = state.auth
  const history = useHistory()

  async function refreshFromToken() {
    await execute(actions.refreshFromToken())
  }

  useEffect(() => {
    const authToken = tokenService.loadToken()

    if (!authToken) {
      history.push('/login')
    } else if (authToken && !user && requestState !== RequestState.Loading && requestState !== RequestState.Error) {
      refreshFromToken()
    }
  })

  return <Route {...rest} render={props => (user ? <PageLayout><Component {...props} /></PageLayout> : '')} />
}

export default PrivateRoute
